import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {DataTableContent as RmwcDataTableContent} from '@rmwc/data-table'
import '@rmwc/data-table/styles'

const StyledRmwcDataTableContent = styled(RmwcDataTableContent)``

const DataTableContent = ({children, ...otherProps}) => <StyledRmwcDataTableContent {...otherProps}>{children}</StyledRmwcDataTableContent>

DataTableContent.propTypes = {
  children: PropTypes.any
}

export {DataTableContent}
